import React from 'react';
export const MenuIcon = () => (
  <svg
    width="18"
    height="12"
    viewBox="0 0 18 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.666992 0H17.3337V2H0.666992V0ZM0.666992 5H17.3337V7H0.666992V5ZM0.666992 10H17.3337V12H0.666992V10Z"
      fill="#0A7593"
    />
  </svg>
);

export const EditUserIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.8965 1.00283C9.96047 0.0667641 8.43779 0.0667641 7.50179 1.00283L2.08053 6.42409C1.68714 6.81748 1.40195 7.30928 1.25482 7.84704L0.416602 10.9209C0.37321 11.0791 0.418387 11.2485 0.534638 11.3648C0.621781 11.4519 0.738478 11.4989 0.858295 11.4989C0.898563 11.4989 0.938741 11.4935 0.978563 11.4828L4.05239 10.6446H4.05284C4.59016 10.4976 5.08193 10.2123 5.47533 9.8189L10.8966 4.39765C11.8327 3.46149 11.8327 1.9389 10.8966 1.00267L10.8965 1.00283Z"
      fill="#0A7593"
    />
    <path
      d="M11.1423 10.5859H6.16674C5.91372 10.5859 5.70898 10.7907 5.70898 11.0437C5.70898 11.2967 5.91372 11.5015 6.16674 11.5015H11.1423C11.3953 11.5015 11.6 11.2967 11.6 11.0437C11.6 10.7907 11.3952 10.5859 11.1422 10.5859H11.1423Z"
      fill="#0A7593"
    />
  </svg>
);

export const EmailUserDisabledIcon = () => (
  <svg
    width="18"
    height="15"
    viewBox="0 0 18 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.99926 0H15.0007C15.829 0 16.5359 0.332849 17.1216 0.998236C17.4129 1.32941 17.6318 1.69452 17.7782 2.09372C17.7676 2.09859 17.7569 2.10377 17.7463 2.1094L16.5813 2.72729L9.00001 6.74774L1.41873 2.72729L0.253692 2.1094C0.243112 2.10392 0.232531 2.09859 0.221816 2.09372C0.3682 1.69452 0.587029 1.32941 0.878322 0.998236C1.46399 0.332849 2.171 0 2.99921 0H2.99926ZM9.25368 8.11805L18 3.47966V11.5915C18 12.5328 17.7071 13.3361 17.1214 14.0016C16.5358 14.6673 15.8289 15 15.0005 15H2.99946C2.17112 15 1.46411 14.6673 0.878438 14.0016C0.292904 13.3361 0 12.5328 0 11.5915V3.47966L8.74632 8.11805C8.82681 8.16066 8.91132 8.18197 9.00011 8.18197C9.08891 8.18197 9.17342 8.16066 9.25391 8.11805H9.25368Z"
      fill="#999999"
    />
  </svg>
);

export const DuplicateIcon = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.1062 4H4.71414C4.32469 4 4 4.32455 4 4.71414V14.1278C4 14.5173 4.32455 14.842 4.71414 14.842H14.1278C14.5173 14.842 14.842 14.5174 14.842 14.1278L14.8418 4.71414C14.8202 4.32469 14.5173 4 14.1061 4H14.1062Z"
      fill="#0A7593"
    />
    <path
      d="M10.963 3.11777V1.49473C10.963 0.997031 10.5735 0.607422 10.0757 0.607422L1.02988 0.607573C0.532187 0.607573 0.142578 1.01878 0.142578 1.49488V10.5407C0.142578 11.0384 0.532033 11.428 1.02988 11.428H3.08571V4.26492C3.08571 3.63742 3.60512 3.11796 4.23266 3.11796L10.963 3.11777Z"
      fill="#0A7593"
    />
  </svg>
);

export const UserLockIcon = () => (
  <svg
    width="13"
    height="17"
    viewBox="0 0 13 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.0004 0.798828C4.14861 0.798828 2.62681 2.30378 2.62696 4.146V5.94771C2.62554 6.29982 2.91166 6.58553 3.2639 6.58427C3.61489 6.58356 3.89859 6.29839 3.89718 5.94771V4.146C3.89718 2.99599 4.82776 2.06814 6.0004 2.06814C7.17305 2.06814 8.10362 2.99595 8.10362 4.146V5.94771C8.10221 6.29982 8.38832 6.58553 8.74071 6.58427C9.09113 6.58285 9.37414 6.29797 9.37272 5.94771V4.146L9.37145 4.10142C9.34723 2.27945 7.83733 0.798828 6.0004 0.798828Z"
      fill="#0A7593"
    />
    <path
      d="M2.75279 5.28939C1.67035 5.28939 0.777344 6.18184 0.777344 7.26319V12.7593C0.777344 13.8408 1.67039 14.7344 2.75279 14.7344H5.85939C6.22001 14.7344 6.38531 14.4682 6.29748 14.1192C6.22511 13.8312 6.18786 13.5347 6.18772 13.2361C6.188 11.225 7.81999 9.59499 9.83256 9.59535C10.0912 9.59535 10.3484 9.62294 10.6 9.67701C10.9519 9.75272 11.2225 9.5785 11.2225 9.21834V7.26417C11.2225 6.18264 10.3331 5.28906 9.25085 5.28906L2.75279 5.28939Z"
      fill="#0A7593"
    />
    <path
      d="M9.83195 10.4746C9.09852 10.4746 8.39515 10.7657 7.87645 11.284C7.3579 11.8023 7.06641 12.505 7.06641 13.2379C7.06641 13.9707 7.3579 14.6736 7.87645 15.1917C8.39515 15.71 9.09852 16.0011 9.83195 16.0011C10.5655 16.0011 11.2689 15.71 11.7876 15.1917C12.3061 14.6736 12.5975 13.9707 12.5976 13.2379C12.5975 12.505 12.3061 11.8021 11.7876 11.284C11.2689 10.7657 10.5655 10.4746 9.83195 10.4746ZM9.82232 11.3014H9.82246C9.89456 11.298 9.96594 11.3169 10.027 11.3556L10.6125 11.7282C10.7132 11.7926 10.7741 11.904 10.7741 12.0234C10.7741 12.1429 10.7132 12.2541 10.6125 12.3186L10.027 12.6913C9.92643 12.7548 9.80051 12.7632 9.69243 12.7135C9.58436 12.6638 9.50873 12.5629 9.49159 12.4453C9.39131 12.4877 9.29924 12.5486 9.22091 12.6271C8.88041 12.9671 8.88041 13.5093 9.22091 13.8492C9.56142 14.1891 10.1043 14.1891 10.4447 13.8492C10.6757 13.6175 10.7477 13.29 10.6647 12.9998H10.6645C10.6121 12.8138 10.7202 12.6206 10.9062 12.5675C11.0923 12.5153 11.2856 12.623 11.3389 12.8086C11.4897 13.3377 11.3533 13.9303 10.9426 14.3437H10.9403C10.3314 14.9516 9.33481 14.9516 8.7259 14.3437C8.11698 13.7357 8.11698 12.7405 8.7259 12.1325C8.93666 11.9221 9.20195 11.7781 9.48819 11.7133V11.6508C9.48875 11.5236 9.5583 11.4067 9.66977 11.3452C9.71694 11.3189 9.76963 11.3039 9.82345 11.3014L9.82232 11.3014Z"
      fill="#0A7593"
    />
  </svg>
);

export const EmailUserIcon = () => (
  <svg
    width="21"
    height="15"
    viewBox="0 0 21 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.49913 0H17.5008C18.4672 0 19.2919 0.332849 19.9752 0.998236C20.315 1.32941 20.5705 1.69452 20.7412 2.09372C20.7289 2.09859 20.7164 2.10377 20.7041 2.1094L19.3448 2.72729L10.5 6.74774L1.65518 2.72729L0.295974 2.1094C0.28363 2.10392 0.271286 2.09859 0.258786 2.09372C0.429566 1.69452 0.684868 1.32941 1.02471 0.998236C1.70799 0.332849 2.53283 0 3.49908 0H3.49913ZM10.796 8.11805L21 3.47966V11.5915C21 12.5328 20.6583 13.3361 19.975 14.0016C19.2917 14.6673 18.467 15 17.5006 15H3.49937C2.53297 15 1.70813 14.6673 1.02484 14.0016C0.341721 13.3361 0 12.5328 0 11.5915V3.47966L10.204 8.11805C10.2979 8.16066 10.3965 8.18197 10.5001 8.18197C10.6037 8.18197 10.7023 8.16066 10.7962 8.11805H10.796Z"
      fill="#0A7593"
    />
  </svg>
);

export const EditUserDisabledIcon = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.8965 1.00283C9.96047 0.0667641 8.43779 0.0667641 7.50179 1.00283L2.08053 6.42409C1.68714 6.81748 1.40195 7.30928 1.25482 7.84704L0.416602 10.9209C0.37321 11.0791 0.418387 11.2485 0.534638 11.3648C0.621781 11.4519 0.738478 11.4989 0.858295 11.4989C0.898563 11.4989 0.938741 11.4935 0.978563 11.4828L4.05239 10.6446H4.05284C4.59016 10.4976 5.08193 10.2123 5.47533 9.8189L10.8966 4.39765C11.8327 3.46149 11.8327 1.9389 10.8966 1.00267L10.8965 1.00283Z"
      fill="#999999"
    />
    <path
      d="M11.1423 10.5859H6.16674C5.91372 10.5859 5.70898 10.7907 5.70898 11.0437C5.70898 11.2967 5.91372 11.5015 6.16674 11.5015H11.1423C11.3953 11.5015 11.6 11.2967 11.6 11.0437C11.6 10.7907 11.3952 10.5859 11.1422 10.5859H11.1423Z"
      fill="#999999"
    />
  </svg>
);

export const UserLockDIsabledIcon = () => (
  <svg
    width="13"
    height="17"
    viewBox="0 0 13 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.0004 0.798828C4.14861 0.798828 2.62681 2.30378 2.62696 4.146V5.94771C2.62554 6.29982 2.91166 6.58553 3.2639 6.58427C3.61489 6.58356 3.89859 6.29839 3.89718 5.94771V4.146C3.89718 2.99599 4.82776 2.06814 6.0004 2.06814C7.17305 2.06814 8.10362 2.99595 8.10362 4.146V5.94771C8.10221 6.29982 8.38832 6.58553 8.74071 6.58427C9.09113 6.58285 9.37414 6.29797 9.37272 5.94771V4.146L9.37145 4.10142C9.34723 2.27945 7.83733 0.798828 6.0004 0.798828Z"
      fill="#999999"
    />
    <path
      d="M2.75279 5.28939C1.67035 5.28939 0.777344 6.18184 0.777344 7.26319V12.7593C0.777344 13.8408 1.67039 14.7344 2.75279 14.7344H5.85939C6.22001 14.7344 6.38531 14.4682 6.29748 14.1192C6.22511 13.8312 6.18786 13.5347 6.18772 13.2361C6.188 11.225 7.81999 9.59499 9.83256 9.59535C10.0912 9.59535 10.3484 9.62294 10.6 9.67701C10.9519 9.75272 11.2225 9.5785 11.2225 9.21834V7.26417C11.2225 6.18264 10.3331 5.28906 9.25085 5.28906L2.75279 5.28939Z"
      fill="#999999"
    />
    <path
      d="M9.83195 10.4746C9.09852 10.4746 8.39515 10.7657 7.87645 11.284C7.3579 11.8023 7.06641 12.505 7.06641 13.2379C7.06641 13.9707 7.3579 14.6736 7.87645 15.1917C8.39515 15.71 9.09852 16.0011 9.83195 16.0011C10.5655 16.0011 11.2689 15.71 11.7876 15.1917C12.3061 14.6736 12.5975 13.9707 12.5976 13.2379C12.5975 12.505 12.3061 11.8021 11.7876 11.284C11.2689 10.7657 10.5655 10.4746 9.83195 10.4746ZM9.82232 11.3014H9.82246C9.89456 11.298 9.96594 11.3169 10.027 11.3556L10.6125 11.7282C10.7132 11.7926 10.7741 11.904 10.7741 12.0234C10.7741 12.1429 10.7132 12.2541 10.6125 12.3186L10.027 12.6913C9.92643 12.7548 9.80051 12.7632 9.69243 12.7135C9.58436 12.6638 9.50873 12.5629 9.49159 12.4453C9.39131 12.4877 9.29924 12.5486 9.22091 12.6271C8.88041 12.9671 8.88041 13.5093 9.22091 13.8492C9.56142 14.1891 10.1043 14.1891 10.4447 13.8492C10.6757 13.6175 10.7477 13.29 10.6647 12.9998H10.6645C10.6121 12.8138 10.7202 12.6206 10.9062 12.5675C11.0923 12.5153 11.2856 12.623 11.3389 12.8086C11.4897 13.3377 11.3533 13.9303 10.9426 14.3437H10.9403C10.3314 14.9516 9.33481 14.9516 8.7259 14.3437C8.11698 13.7357 8.11698 12.7405 8.7259 12.1325C8.93666 11.9221 9.20195 11.7781 9.48819 11.7133V11.6508C9.48875 11.5236 9.5583 11.4067 9.66977 11.3452C9.71694 11.3189 9.76963 11.3039 9.82345 11.3014L9.82232 11.3014Z"
      fill="#999999"
    />
  </svg>
);

export const DuplicateDisabledIcon = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.1062 4H4.71414C4.32469 4 4 4.32455 4 4.71414V14.1278C4 14.5173 4.32455 14.842 4.71414 14.842H14.1278C14.5173 14.842 14.842 14.5174 14.842 14.1278L14.8418 4.71414C14.8202 4.32469 14.5173 4 14.1061 4H14.1062Z"
      fill="#999999"
    />
    <path
      d="M10.963 3.11777V1.49473C10.963 0.997031 10.5735 0.607422 10.0757 0.607422L1.02988 0.607573C0.532187 0.607573 0.142578 1.01878 0.142578 1.49488V10.5407C0.142578 11.0384 0.532033 11.428 1.02988 11.428H3.08571V4.26492C3.08571 3.63742 3.60512 3.11796 4.23266 3.11796L10.963 3.11777Z"
      fill="#999999"
    />
  </svg>
);
